module.exports = __webpack_public_path__ + "img/firefox_48x48.eb7eac11.png";